import Loadable from 'react-loadable';

export const IssueReportLoadable = Loadable({
  loader: () => import(/* webpackChunkName: "reportIssue" */ './index'),
  loading: () => null,
});
